<div class="layer absolute flex flex-column overflow-hidden" [ngStyle]="style" [class.scale-in-tr]="activateAnimation" [class.dark]="dark">
  <div class="flex align-items-center mt-1 justify-content-center gap-2" (click)="updateStyle()">
    <label class="ml-2">Mostrar dispositivos</label>
    <i class="pi pi-chevron-down"></i>
  </div>

  <ng-container *ngIf="open">
    <div class="filters-row flex gap-2" [class.has-lote-filter]="lotes.length > 0">
      <p-multiSelect
        *ngIf="lotes.length > 0"
        [options]="lotes"
        [(ngModel)]="selectedLotes"
        (ngModelChange)="loteModelChanges($event)"
        [maxSelectedLabels]="lotes.length"
        selectedItemsLabel="{0} Lotes selecionados"
        optionLabel="description"
        optionValue="id"
        styleClass="lote-multiselect"
        display="chip"
        [showToggleAll]="false"
        [filter]="true"
        [showClear]="true"
        placeholder="Lote"
      >
        <ng-template let-lote pTemplate="item">
          <div class="font-semibold text-center">
            {{ lote.description }}
          </div>
        </ng-template>
      </p-multiSelect>

      <span class="p-input-icon-left equipment-filter">
        <i class="pi pi-search"></i>
        <input type="text" [value]="filter" pInputText placeholder="Nome do Equipamento" (input)="search($event)" />
      </span>
    </div>

    <div class="actions flex align-items-center justify-content-between w-full p-2 mb-2">
      <p>Filtrar</p>

      <div class="badges flex flex-wrap justify-content-end">
        <div
          class="badge total"
          [class.active]="activeStatusFilter === 'total'"
          tooltipPosition="left"
          appendTo="body"
          tooltipStyleClass="status-tooltip"
          [escape]="false"
          pTooltip="Todos os Equipamentos"
          (click)="setFilterStatus('total')"
        >
          <i class="fas fa-list mr-1"></i> {{ getStatus().total }}
        </div>

        <div
          class="badge"
          [class.active]="activeStatusFilter === 'on'"
          tooltipPosition="left"
          appendTo="body"
          tooltipStyleClass="status-tooltip"
          [escape]="false"
          pTooltip="<strong>Online</strong><br>
            O último status registrado indica que o equipamento está online e com os dados atualizados. Esse registro está dentro do prazo de atualização do monitoramento.
            A indicação reflete a última avaliação disponível e não garante comunicação ou recebimento de passagens neste exato momento.
            <br><br>
            <strong>Contrato acessado:</strong><br>
            {{ getActiveContractName() }}
            <br><br>
            <strong>Prazo conforme o perfil ativo:</strong><br>
            {{ getActiveProfileTooltip() }}
            <br><br>
            <strong>Consulta na tela:</strong><br>
            A cada 10 minutos, a tela busca no serviço o status disponível do equipamento. Entre as consultas, exibe o último resultado recebido. Essa consulta não confirma comunicação ou passagem neste instante."
          (click)="setFilterStatus('on')"
        >
          <i class="fas fa-check-circle mr-1"></i> {{ getStatus().on }}
        </div>

        <div
          class="badge nopass"
          [class.active]="activeStatusFilter === 'no-pass'"
          tooltipPosition="left"
          appendTo="body"
          tooltipStyleClass="status-tooltip"
          [escape]="false"
          pTooltip="<strong>Em atraso</strong><br>
            O último status registrado indica que o equipamento está online, mas com dados em atraso. A atualização do monitoramento permanece dentro do prazo, porém a avaliação ainda aponta pendência na atualização dos dados.
            Consulte a última passagem e os registros por pista para acompanhar os dados disponíveis. Este indicador, sozinho, não informa a causa do atraso.<br><br>
            <strong>Contrato acessado:</strong><br>
            {{ getActiveContractName() }}
            <br><br>
            <strong>Prazo conforme o perfil ativo:</strong><br>
            {{ getActiveProfileTooltip() }}<br>
            Esses prazos se referem à atualização do status, não ao atraso das passagens.
            <br><br>
            <strong>Consulta na tela:</strong><br>
            A cada 10 minutos, a tela busca no serviço o status disponível do equipamento. Entre as consultas, exibe o último resultado recebido. Esse intervalo não define o prazo para considerar o equipamento em atraso."
          (click)="setFilterStatus('no-pass')"
        >
          <i class="fas fa-exclamation-circle mr-1"></i> {{ getStatus().noPass }}
        </div>

        <div
          class="badge danger"
          [class.active]="activeStatusFilter === 'off'"
          tooltipPosition="left"
          appendTo="body"
          tooltipStyleClass="status-tooltip"
          [escape]="false"
          pTooltip="<strong>Offline</strong><br>
            O equipamento possui uma indicação de offline ou seu registro de status ficou sem atualização por mais tempo que o permitido. Essa classificação também pode aparecer quando não há um status disponível ou ocorre uma falha ao consultá-lo.
  O indicador não confirma, por si só, que o radar esteja desligado e não identifica a causa da indisponibilidade.
            <br><br>
            <strong>Contrato acessado:</strong><br>
            {{ getActiveContractName() }}
            <br><br>
            <strong>Prazo conforme o perfil ativo:</strong><br>
            {{ getActiveProfileTooltip() }}<br>
            O prazo é contado desde a última atualização do status, não desde a última passagem.
            <br><br>
            <strong>Consulta na tela:</strong><br>
            A cada 10 minutos, a tela busca no serviço o status disponível do equipamento. Entre as consultas, exibe o último resultado recebido. Esse intervalo não define o prazo para considerar o equipamento offline."
          (click)="setFilterStatus('off')"
        >
          <i class="fas fa-times-circle mr-1"></i> {{ getStatus().off }}
        </div>
      </div>
    </div>

    <div class="items flex flex-column flex-auto overflow-y-auto" *ngIf="open">
      <div class="flex align-items-center gap-2" *ngFor="let item of dataMetricsFiltered; let i = index">
        <span
          *ngIf="item.groupId === GroupEnum.ESPIRITO_SANTO || item.groupId === GroupEnum.PRF || item.groupId === GroupEnum.SERRA_GAUCHA"
          [pTooltip]="!isButtonEnabled(item) ? getButtonTooltip(item) : ''"
          tooltipPosition="left"
          appendTo="body"
          [showDelay]="300"
        >
          <p-button
            label="Acessar"
            [style]="{'height': '1rem'}"
            styleClass="font-semibold text-base"
            [disabled]="!isButtonEnabled(item)"
            (onClick)="goToEquipment($event, item)"
          ></p-button>
        </span>

        <div
          class="item relative flex align-items-center justify-content-between flex-1 cursor-pointer"
          (click)="selectDevice(item)"
          [class.nopass]="item.statusOnline == 1"
          [class.disabled]="item.statusOnline == 0"
          [class.warn]="item.statusOnline == 3"
          [class.other]="item.statusOnline != 0 && item.statusOnline != 1 && item.statusOnline != 2 && item.statusOnline != 3"
        >
          <h6 class="font-bold text-base m-0 flex-1 min-w-0">{{ item.deviceName }} - {{ item.streetName }}</h6>
          <i class="fa-solid fa-location-dot flex-none" style="font-size: 0.8rem"></i>
        </div>
      </div>
    </div>
  </ng-container>
</div>
